function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-heater",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "26-desktop-UI-heater",
  transform: "translate(-572.000000, -1324.000000)",
  strokeWidth: 2
}, React.createElement("g", {
  id: "heater-heater",
  transform: "translate(573.000000, 1325.000000)"
}, React.createElement("path", {
  d: "M10,28 L16,28",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M26,28 L32,28",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M42,28 L48,28",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M10,51 L16,51",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M26,51 L32,51",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M42,51 L48,51",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M29,11 L29,0",
  id: "Path-heater",
  stroke: "#6EC18A"
}), React.createElement("path", {
  d: "M15,13 L15,6",
  id: "Path-heater",
  stroke: "#6EC18A"
}), React.createElement("path", {
  d: "M43,13 L43,6",
  id: "Path-heater",
  stroke: "#6EC18A"
}), React.createElement("path", {
  d: "M5,19 L5,19 C2.2,19 0,21.2 0,24 L0,55 C0,57.8 2.2,60 5,60 L5,60 C7.8,60 10,57.8 10,55 L10,24 C10,21.2 7.8,19 5,19 Z",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M21,19 L21,19 C18.2,19 16,21.2 16,24 L16,55 C16,57.8 18.2,60 21,60 L21,60 C23.8,60 26,57.8 26,55 L26,24 C26,21.2 23.8,19 21,19 Z",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M37,19 L37,19 C34.2,19 32,21.2 32,24 L32,55 C32,57.8 34.2,60 37,60 L37,60 C39.8,60 42,57.8 42,55 L42,24 C42,21.2 39.8,19 37,19 Z",
  id: "Path-heater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M53,19 L53,19 C50.2,19 48,21.2 48,24 L48,55 C48,57.8 50.2,60 53,60 L53,60 C55.8,60 58,57.8 58,55 L58,24 C58,21.2 55.8,19 53,19 Z",
  id: "Path-heater",
  stroke: "#3F5063"
}))));

var SvgHeater = function SvgHeater(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "60px",
    height: "62px",
    viewBox: "0 0 60 62",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeater, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heater.15dc9f22.svg";
export { ForwardRef as ReactComponent };